module.exports = __webpack_public_path__ + "img/naumov.047c906b.jpg";